import React from 'react';
import styled from 'styled-components/macro';

const Asterisk = props => <span {...props}>*</span>;

export const RequiredAsterisk = styled(Asterisk)`
  color: ${({ theme }) => theme.palette.error.main};
  font-size: 20px;
  line-height: 0;
  margin: 0 0.2ch;
`;
